import React from 'react';
import { 
  Box,
  Typography,
  Divider,
  TextField,
  Switch,
  Button,
  useMediaQuery,
  useTheme
} from '@mui/material';
// import userIcon from '../../Images/userIcon.png';
import userIcon2 from '../../Images/userIcon2.png';
import { styled } from '@mui/system';
// import { Brightness4, Brightness7 } from '@mui/icons-material';
import PropTypes from 'prop-types';

import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
// import { useThemeContext } from '../../Context/ThemeContext';

// Styled TextField
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.secondary.default,
    borderRadius: '10px',
    marginBottom: '1rem',
    height: '2.5rem',
  },
  '& .MuiOutlinedInput-input-focused': {
    borderColor: theme.palette.text.primary,
  },
}));

export default function ManageProfile() {
  // const { darkMode, toggleDarkMode } = useThemeContext();
  const navigate = useNavigate();
  const theme = useTheme(); // Use the theme from MUI's ThemeProvider
  
  // Responsive breakpoints
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm')); // Mobile
  const isMdScreen = useMediaQuery(theme.breakpoints.down('md')); // Tablet

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", overflow: "hidden", bgcolor: "background.default" }}>
      <Sidebar />

      <Box 
        sx={{
          padding: isSmScreen ? '1rem' : '2rem',
          marginLeft: '190px',
          width: 'calc(100% - 190px)',
        }}
      >
        {/* Profile Header */}
        <Box 
          sx={{ 
            display: 'flex',
            flexDirection: isSmScreen ? 'column' : 'row',
            alignItems: 'center',
            gap: 2,
            mb: 4
          }}
        >
          <Box
            component="img"
            src={userIcon2}
            alt="User Icon"
            sx={{
              width: isSmScreen ? '3rem' : '3.5rem',
              height: isSmScreen ? '3rem' : '3.5rem',
              borderRadius: '50%'
            }}
          />
          <Typography sx={{ fontSize: isSmScreen ? '1rem' : '1.2rem', fontWeight: 600, color: 'text.primary' }}>
            ABD23431
          </Typography>
          <Button 
            variant="outlined"
            sx={{ 
              ml: isSmScreen ? 0 : 'auto',
              mt: isSmScreen ? 2 : 0,
              width: isSmScreen ? '100%' : 'auto'
            }}
            onClick={() => navigate('/userdashboard')}
          >
            Dashboard
          </Button>
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMdScreen ? 'column' : 'row',
            gap: isSmScreen ? '2rem' : '4rem',
            px: isSmScreen ? '0' : '4rem'
          }}
        >
          {/* Left Section */}
          <Box sx={{ width: isMdScreen ? '100%' : '50%' }}>
            <Typography sx={{ fontSize: '1.1rem', mb: 2, fontWeight: 600, color: 'text.primary' }}>
              User Details
            </Typography>

            <Typography sx={{ fontSize: '0.9rem', mb: 1, color: 'text.primary' }}>User Name</Typography>
            <StyledTextField fullWidth />

            <Typography sx={{ fontSize: '0.9rem', mb: 1, color: 'text.primary' }}>User Email</Typography>
            <StyledTextField fullWidth />

            <Typography sx={{ fontSize: '0.9rem', mb: 1, color: 'text.primary' }}>Contact No</Typography>
            <StyledTextField fullWidth />

            <Typography sx={{ fontSize: '1.1rem', mb: 2, fontWeight: 600, mt: 4, color: 'text.primary' }}>
              Notification Settings
            </Typography>

            {[
              'Project notification',
              'Workflow failure notification',
              'Password expiration',
              'Tool Notification Admin'
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  mb: 2
                }}
              >
                <Typography sx={{ fontSize: '0.9rem', color: 'text.primary' }}>{item}</Typography>
                <Switch defaultChecked={index !== 1} color="primary" />
              </Box>
            ))}
          </Box>

          {/* Divider for larger screens */}
          {!isMdScreen && (
            <Divider orientation="vertical" flexItem />
          )}

          {/* Right Section */}
          <Box sx={{ width: isMdScreen ? '100%' : '50%' }}>
            <Typography sx={{ fontSize: '1.1rem', mb: 2, fontWeight: 600, color: 'text.primary' }}>
              Themes
            </Typography>

            {/* Light/Dark Mode Toggle Buttons - COMMENTED OUT */}
            {/* <Box
              sx={{
                display: 'flex',
                flexDirection: isSmScreen ? 'column' : 'row',
                gap: 2,
                mb: 4
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleDarkMode()}
                sx={{
                  width: isSmScreen ? '100%' : '8rem',
                  height: '7rem',
                  borderRadius: '1rem',
                  bgcolor: darkMode ? 'secondary.default' : 'background.default',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                  borderColor: darkMode ? 'primary.main' : 'grey.400',
                }}
              >
                <Brightness4
                  sx={{
                    fontSize: '2.5rem',
                    color: darkMode ? 'primary.main' : 'text.secondary'
                  }}
                />
                <Typography color="text.primary">Dark mode</Typography>
              </Button>

              <Button
                variant="outlined"
                onClick={() => toggleDarkMode()}
                sx={{
                  width: isSmScreen ? '100%' : '8rem',
                  height: '7rem',
                  borderRadius: '1rem',
                  bgcolor: !darkMode ? 'secondary.default' : 'background.default',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                  borderColor: !darkMode ? 'primary.main' : 'grey.400',
                }}
              >
                <Brightness7
                  sx={{
                    fontSize: '2.5rem',
                    color: !darkMode ? 'primary.main' : 'text.secondary'
                  }}
                />
                <Typography color="text.primary">Light mode</Typography>
              </Button>
            </Box> */}

            <Typography sx={{ fontSize: '1.1rem', mb: 2, fontWeight: 600, color: 'text.primary' }}>
              Account Settings
            </Typography>

            {/* Additional account settings components can be added here */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

ManageProfile.propTypes = {
  setCurrentView: PropTypes.func
};